import { Component, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { UntypedFormGroup, FormsModule } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { ISelectOptionGroup } from 'projects/bis-shared/src/lib/dynamic-forms/models/select-option-group';
import { ObjectRequest } from './bulk-edit-objects.data';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FormUtility } from 'projects/bis-shared/src/lib/dynamic-forms/services/form-utility/form-utility';
import { SnackbarService } from 'projects/bis-shared/src/lib/snackbar/snackbar.service';
import { ServiceHelpers } from 'projects/bis-shared/src/lib/utility/service-helpers';
import { HttpClient } from '@angular/common/http';
import { BulkEditObjectService } from './bulk-edit-object.service';
import { ExternalApiUrls } from 'projects/bis-shared/src/lib/utility/apiurls-external';
import { DynamicFormsService } from 'projects/bis-shared/src/lib/dynamic-forms/services/dynamic-forms/dynamic-forms.service';
import { IDynamicFormGroupDefinition } from 'projects/bis-shared/src/lib/dynamic-forms/models/dynamic-form-group';
import { DynamicFormLoadDirective } from '../../../../bis-shared/src/lib/dynamic-forms/directives/dynamic-form-structural.directive';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { SelectInputComponent } from '../../../../bis-shared/src/lib/dynamic-forms/dynamic-form-inputs/select-input/select-input.component';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-bulk-edit-objects',
  templateUrl: './bulk-edit-objects.component.html',
  styleUrls: ['./bulk-edit-objects.component.scss'],
  imports: [
    DynamicFormLoadDirective,
    FormsModule,
    CdkScrollable,
    MatDialogContent,
    SelectInputComponent,
    MatDialogActions,
    MatButton,
  ],
})
export class BulkEditObjectsComponent implements OnInit {
  data = inject(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<BulkEditObjectsComponent>>(MatDialogRef);
  private dynamicFormsService = inject(DynamicFormsService);
  private snackbarService = inject(SnackbarService);
  private bulkEditObjectService = inject(BulkEditObjectService);
  private externalApiUrls = inject(ExternalApiUrls);
  private http = inject(HttpClient);

  objectRequestForm: UntypedFormGroup;
  formInfo: IDynamicFormGroupDefinition;
  workAssignees$: BehaviorSubject<ISelectOptionGroup[]> = new BehaviorSubject([]);
  objectRequest: ObjectRequest;
  @Output() saved: EventEmitter<ObjectRequest> = new EventEmitter();
  errorMessage: string;

  
 

  constructor() {
    const data = this.data;

    this.objectRequest = data;
  }
  ngOnInit(): void {
    this.dynamicFormsService.getFormGroupForModel('bulkObjectRequestForm').subscribe(formInfo => {
      this.formInfo = formInfo;
      this.objectRequestForm = formInfo.formGroup;
      if (this.objectRequest) {
        this.objectRequestForm.patchValue(this.objectRequest);
      }
    });

    this.getAssignees(this.objectRequest.assignedToWorkGroupId);
  }

  getAssignees(groupId: number, supervisorSystemUserId?: number) {
    if (supervisorSystemUserId) {
      this.objectRequestForm.patchValue({ assignedToSystemUserId: supervisorSystemUserId });
    }

    this.bulkEditObjectService.getAssignees(groupId).subscribe(forms => {
      this.workAssignees$.next(forms);
    });
  }
  bulkObjectUpdate(objectRequest: ObjectRequest): Observable<ObjectRequest> {
    return this.http.put<ObjectRequest>(
      this.externalApiUrls.priorAuthorizationWorkRequest.bulkUpdate(),
      objectRequest,
    );
  }
  update() {
    FormUtility.onBeforeSave(this.objectRequestForm);
    if (this.objectRequestForm.valid) {
      this.bulkObjectUpdate(this.objectRequestForm.value).subscribe(
        cl => {
          this.snackbarService.openSnackBarSuccess('Update successful!');
          this.saved.emit(cl);
          this.dialogRef.close(true);
        },
        error => {
          this.errorMessage = ServiceHelpers.getErrorMessage(error, 'Error: Update Failed.');
        },
      );
    }
  }

  cancel() {
    this.dialogRef.close();
  }
}
